import React, { useEffect, useRef, useState } from 'react';
import './skills.css';

const SKILLS = [
  {
    id: 'autocad',
    title: 'AUTOCAD CIVIL 3D',
    icon: '\u25C7', // ◇
    items: [
      'Grading Design',
      'Servicing',
      'Private Servicing',
      'Erosion & Sediment Control',
      'Stormwater Management',
      'On-site Sewage System Design',
      'Construction Documentation',
      'Utility Layout',
      'Earthwork Calculations',
    ],
  },
  {
    id: 'gis',
    title: 'ARCGIS & QGIS',
    icon: '\u25C8', // ◈
    items: [
      'Surface Modeling',
      'Topographic Analysis',
      'Hydrological Studies',
      'Land Use Analysis',
    ],
  },
  {
    id: 'bluebeam',
    title: 'BLUEBEAM REVU',
    icon: '\u25A3', // ▣
    items: [
      'Markup & Review',
      'Drawing Coordination',
      'PDF Drafting',
      'Custom Tool Library Development',
    ],
  },
  {
    id: 'office',
    title: 'MS OFFICE & GOOGLE',
    icon: '\u25A4', // ▤
    items: [
      'RFP / Proposal Development',
      'Technical Writing & Editing',
      'VBA Automation',
      'Data Analysis & Visualization',
      'Pivot Tables & Reporting',
    ],
  },
  {
    id: 'programming',
    title: 'PROGRAMMING',
    icon: '</>',
    items: ['Python', 'JavaScript', 'AutoLISP', 'Design Automation', 'Scripting'],
  },
  {
    id: 'pm',
    title: 'PROJECT MANAGEMENT',
    icon: '\u25A6', // ▦
    items: [
      'Multi-Project Coordination',
      'Risk Assessment',
      'RFP Procurement',
      'Cost Estimation',
    ],
  },
  {
    id: 'field',
    title: 'FIELD EXPERIENCE',
    icon: '\u2316', // ⌖
    items: [
      'Construction Inspection & Review',
      'Constructability Planning',
      'Site Constraint Analysis',
      'Geotechnical Observation',
    ],
  },
];

export const Skills = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.05 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="Skills"
      className={`skills-section ${visible ? 'visible' : ''}`}
      ref={ref}
      aria-label="Skills"
    >
      <div className="container">
        <div className="section-header">
          <h2>SKILLS</h2>
        </div>

        <div className="skills-grid">
          {SKILLS.map((cat, idx) => (
            <div
              key={cat.id}
              className="skill-card terminal-window"
              style={{ animationDelay: `${idx * 0.08}s` }}
            >
              <div className="terminal-header">
                <span className="skill-icon">{cat.icon}</span>
                <span>{cat.title}</span>
              </div>
              <div className="terminal-body">
                <ul className="skill-list">
                  {cat.items.map((item, i) => (
                    <li key={i} className="skill-item">
                      <span className="bullet">{'\u25B8'}</span> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
